export const DEFAULT_TEXTS = {
  navigation: {
    back: "Back",
    next: "Next",
    submit: "Submit"
  },
  success: {
    title: "Form submitted successfully",
    description: "Thank you for your time and attention!",
    buttonText: "Submit again"
  },
  errors: {
    loadForm: "Failed to load form",
    submitForm: "Failed to submit form"
  }
};
